import { Product } from '@fandom/context';
import { CurrentPageType, F2_PAGES } from 'pathfinder/modules/RegistrationButton/types';
import { getCurrentContext } from 'pathfinder/modules/RegistrationButton/utils/getCurrentContext';
export const getCurrentPage = () => {
    const { product, page } = getCurrentContext();
    if (!product || !page) {
        console.error('Could not get current context from SilverSurfer API');
        return;
    }
    // Supported pages for this module
    if (product === Product.MEDIAWIKI || product === Product.DISCUSSIONS) {
        return CurrentPageType.WIKI_RELATED;
    }
    if (product === Product.FANHUB) {
        return CurrentPageType.FAN_CENTRAL;
    }
    if (product === Product.F2 && page === F2_PAGES.HOME) {
        return CurrentPageType.F2_HOMEPAGE;
    }
    if (product === Product.F2 && page === F2_PAGES.TOPIC) {
        return CurrentPageType.F2_TOPIC_PAGE;
    }
    if (product === Product.F2 && window.location.href.includes('fandom.com/articles/')) {
        return CurrentPageType.F2_EDITORIAL_PAGE;
    }
};
